import * as X from "@/ui";

import { JSX } from "react";
import { StrapiImage } from "@/providers/strapi";
import { RatingCard, Testimonial, TestimonialSlide } from "@/providers/strapi/content/types/components/traveler.component";
import ReactMarkdown from "react-markdown";


type DataType = {
  // title: {
  //   en: JSX.Element,
  //   fr: JSX.Element
  // },
  cta: string
  testimonials: Array<{
    name: string
    photo: StrapiImage,
    text: JSX.Element
  }>
}
const buildData = (testimonials: Testimonial): DataType => ({
  cta: testimonials.cta,
  testimonials: testimonials.testimonialSlides.map((t: TestimonialSlide) => ({
    name: t.name,
    photo: t.avatar,
    text: <ReactMarkdown>{t.content}</ReactMarkdown>
  }))
})
// const data = {
//   title: {
//     en: <>They’ve already joined us. <strong>Why not you?</strong></>,
//     fr: <>Un service d’expert <strong>digne de votre confiance</strong></>,
//   },

//   cta: {
//     en: "Become a partner",
//     fr: "Devenir partenaire",
//   },

//   testimonials: [
//     {
//       name: {
//         en: "Alexandre Beudet, Founder & CEO of Excellence Rhum",
//         fr: "Alexandre Beudet, Fondateur et CEO d'Excellence Rhum",
//       },
//       photo: PhotoRhum,
//       text: {
//         en: "With a clientele of spirits enthusiasts all over the world, we need efficient, tailored solutions for both our Paris boutique and our e-commerce site. Zapptax provides that flexibility by simplifying tax-free shopping for our international customers and streamlining our administrative processes. It’s a smooth, well-designed service for both retail and online sales, allowing us to fully focus on our mission: offering the finest spirits to collectors and connoisseurs around the globe.",
//         fr: `Avec une clientèle de passionnés de spiritueux aux quatre coins du monde, nous avons besoin de solutions efficaces et adaptées aussi bien à notre boutique parisienne qu’à notre site e-commerce. Zapptax nous apporte cette flexibilité en simplifiant la détaxe pour nos clients internationaux et en optimisant notre gestion administrative. Un service fluide et pensé pour le retail comme pour l’e-commerce, qui nous permet de nous concentrer pleinement sur notre mission${X.Nbsp}: proposer les meilleurs spiritueux aux amateurs et collectionneurs du monde entier.`,
//       },
//     },
//     {
//       name: {
//         en: "Marc-Antoine de Morel - Head of Customer Support at Gong Galaxy",
//         fr: "Marc-Antoine de Morel - Head of Customer Support chez Gong Galaxy",
//       },
//       photo: PhotoGong,
//       text: {
//         en: "We recommend our customers to use Zapptax to simplify the VAT refund process for their orders. With this solution, they benefit from a fast and streamlined VAT refund. On our side, it saves us time and allows our teams to focus on enhancing the customer relationship.",
//         fr: "Nous recommandons à nos clients d'utiliser Zapptax pour simplifier la détaxe de leurs commandes. Grâce à cette solution, ils bénéficient d'un remboursement de la TVA rapide et simplifié. De notre côté, nous gagnons du temps, permettant à nos équipes de se concentrer sur l'amélioration de la relation client.",
//       },
//     },
//     {
//       name: {
//         en: "Bertrand Gasselin, Co-founder of Seagale",
//         fr: "Bertrand Gasselin, co-fondateur de Seagale",
//       },
//       photo: PhotoSeagale,
//       text: {
//         en: "We spend years developing technical and durable clothing, so we’re not about to waste time on a complicated VAT refund process. Zapptax is exactly the solution we needed: a simple interface and a seamless experience, both online and in-store. It’s a real time-saver — for us and for our customers.",
//         fr: "On passe des années à développer des vêtements techniques et durables, alors on ne va pas perdre du temps sur une détaxe compliquée. Zapptax, c’est la solution qu’il nous fallait : une interface simple, un fonctionnement sans friction, en ligne comme en boutique. Un vrai gain de temps pour nous et nos clients.",
//       },
//     },
//   ],
// };


export function TestimonialsSection(props: X.PageProps<{ testimonials: Testimonial, ratingCard: RatingCard }>) {
  // const tr = X.useTranslator();

  const ratingCard = props.ratingCard;//useRetailerHomePage('ratingCard')

  const data = buildData(props.testimonials)
  return (
    <X.TestimonialsSection
      id="testimonials"
      // title={props.ratingCard.title}//{{ fr: props.ratingCard.title, en: props.ratingCard.title }}
      testimonials={props.testimonials.testimonialSlides}
      className="mb-12 xl:mb-24 xl:my-20"
      locale={props.locale}
      ratingCard={ratingCard}
      cta={(
        <X.Button
          primary lg
          href="/retail/become-partner"
          label={
            data.cta
            // tr(data.cta)
          }
        />
      )}
    />
  );
}
